import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import {
  useLocation,
  withRouter,
} from "react-router-dom/cjs/react-router-dom.min";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import swal from "sweetalert";
import {
  convertToDateString,
  isUrdu,
  LoadingSpinner,
} from "../../../constants/const";
import { GetLanguageString } from "../../helper/Components";
import {
  GetCustomStyles,
  GetPeriodName,
  GetSelectedLanguage,
} from "../../helper/Method";
import { addMember } from "../ApiMember";
import LetterForCounsellingDataTable from "./LetterForCounsellingDataTable";
import LetterForCounsellingMemberDataContainer from "./LetterForCounsellingMemberDataContainer";

const EditLetterForCounselling = ({ history }) => {
  const location = useLocation();
  const currentDate = new Date();
  const memberId = location.state?.memberId;
  const letterForCounselling = location.state?.letterForCounselling;
  const receivedLetterForCounsellingId =
    location.state?.receivedLetterForCounsellingId;
  const letterForFrequency = location.state?.letterForFrequency;
  const letterFrequency = location.state?.letterFrequency;
  const memberValues = location.state?.memberValues;
  const receivedAt = location.state?.receivedAt;
  const letterYear = location.state?.letterYear;
  const calledAs = location.state?.calledAs;
  const commentsData = location.state?.commentsData;

  const [letterColor, setLetterColor] = useState("");
  const [responsibileNames, setResponsibileNames] = useState({});
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState({
    questions: "",
  });
  const [selectedDate, setSelectedDate] = useState(new Date(receivedAt));

  const [loading, setLoading] = useState(false);

  const [questionsList, setQuestionsList] = useState([]);

  useEffect(() => {
    setLoading(true);
    addMember()
      .EditReceivedLetterForCounselling(receivedLetterForCounsellingId)
      .then((res) => {
        let tempValues = [...res.data.memberLetterForCounsellingQuestions];

        tempValues = tempValues.map((question) => {
          return { ...question, errorColor: "#ffffff" };
        });
        setQuestionsList(tempValues);
        setLetterColor(res.data.letterColor);
        setResponsibileNames({
          naqeebName: res.data.naqeebName,
          muqamiAmeerName: res.data.muqamiAmeerName,
          ameerHalqaName: res.data.ameerHalqaName,
          naibNazimAllaName: res.data.naibNazimAllaName,
          nazimAllaName: res.data.nazimAllaName,
          ameerMohtaramName: res.data.ameerMohtaramName,
        });

        setLoading(false);
      })
      .catch((err) => {
        swal({
          title: err,
          icon: "error",
          buttons: "OK",
        });
        setLoading(false);
      });
    // eslint-disable-next-line
  }, [receivedLetterForCounsellingId]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      questionsList.every((question) => question.rating !== 0) &&
      Object.values(errorMessage).every((x) => x === "")
    ) {
      const values = {
        memberId: memberId,
        letterForCounsellingId: receivedLetterForCounsellingId,
        receivedAt: convertToDateString(selectedDate),
        questions: questionsList,
      };
      setLoading(true);
      addMember()
        .EditMemberLetterForCounselling(values)
        .then((res) => {
          swal({
            title: t(
              "member_member_detail_letter_for_counselling_edit_success"
            ),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "success",
            buttons: "OK",
          });
          history.goBack();
          setLoading(false);
        })
        .catch((err) => {
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
        });
    } else {
      setErrorMessage({
        ...errorMessage,
        questions: questionsList.some((question) => question.rating === 0)
          ? "member_member_detail_letter_for_counselling_questions_error_message"
          : "",
      });
    }
  };

  const FeedbackCard = ({
    title,
    responsibleName,
    question = "کیا توجہ طلب امور پر متعلقہ رفیق کو موثر انداز سے توجہ دلائی گئ ہئے؟",
    status,
    feedback,
  }) => {
    const isUrLanguage = GetSelectedLanguage() === "ur";

    return (
      <div
        className="ibox-content p-3 mb-3"
        style={{
          borderRadius: "10px",
          boxShadow: "0 1px 4px rgba(0, 0, 0, 0.06)",
          backgroundColor: "#fff",
          border: "1px solid #e5e7eb",
        }}
      >
        {/* Header */}
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center">
            <h6
              className="fw-bold mb-0"
              style={{ color: "#2d3748", fontSize: "0.95rem" }}
            >
              {title}
            </h6>
          </div>
          <p className="text-muted mb-0 ur mt-1" style={{ fontSize: "0.8rem" }}>
            ({responsibleName})
          </p>
        </div>

        {/* Question + Status */}
        <div
          className="mb-3 p-2 d-flex justify-content-between align-items-center"
          style={{
            backgroundColor: "#f8fafc",
            borderRadius: "6px",
            borderLeft: !isUrLanguage ? "3px solid #4a6fa5" : "none",
            borderRight: isUrLanguage ? "3px solid #4a6fa5" : "none",
            minHeight: "44px",
          }}
        >
          <p
            className={`mb-0 ur fw-bold flex-grow-1`}
            style={{
              color: "#2d3748",
              fontSize: "0.9rem",
              lineHeight: "1.4",
              fontWeight: "500",
              paddingRight: "8px",
            }}
          >
            {question}
          </p>

          <div
            className={`px-2 py-1 ur rounded fw-bold ${
              status ? "bg-success text-white" : "bg-danger text-white"
            }`}
            style={{
              fontSize: "1rem",
              whiteSpace: "nowrap",
              minWidth: "70px",
              textAlign: "center",
            }}
          >
            {status ? "جی ہاں" : "جی نہیں"}
          </div>
        </div>

        {/* Feedback */}
        <div>
          <Label
            className="form-label fw-bold mb-2"
            style={{
              color: "#4a5568",
              fontSize: "0.85rem",
              paddingBottom: "2px",
            }}
          >
            <GetLanguageString props="notifications_feedback" />
          </Label>

          <div className="position-relative">
            <Input
              disabled
              type="textarea"
              className={`form-control ${
                isUrdu(feedback) ? "ur text-end" : ""
              }`}
              value={feedback}
              style={{
                minHeight: "60px",
                borderRadius: "5px",
                backgroundColor: feedback ? "#fff" : "#f8f9fa",
                border: "1px solid #e2e8f0",
                fontSize: "0.9rem",
                padding: "8px 10px",
                lineHeight: "1.4",
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <div className="panel panel-primary">
        <div className="panel-heading">
          {" "}
          <Row>
            <Col md="10"></Col>
            <Col md="2">
              <Button
                color="info"
                size="sm"
                className={GetCustomStyles().btn_style}
                onClick={() => history.goBack()}
              >
                {<GetLanguageString props="unit_back_btn" />}
              </Button>
            </Col>
          </Row>
        </div>
        <div className="panel-body">
          <LetterForCounsellingMemberDataContainer
            memberValues={memberValues}
            calledAs={calledAs}
          />
          <br></br>
          <br></br>
          <Row>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {
                    <GetLanguageString props="member_member_detail_letter_for_counselling_year" />
                  }
                </Label>
                <Input value={letterYear} disabled />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {
                    <GetLanguageString props="settings_letter_for_counselling" />
                  }
                </Label>
                <Input
                  className={"ur"}
                  type="text"
                  disabled
                  value={letterForCounselling}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup style={{ marginTop: 5 }}>
                <Label>
                  {<GetLanguageString props="settings_event_type_frequency" />}
                </Label>

                <Input
                  className={"ur"}
                  type="text"
                  disabled
                  value={GetPeriodName(letterFrequency, letterForFrequency)}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {
                    <GetLanguageString props="member_member_detail_letter_for_counselling_received_date" />
                  }
                </Label>
                <DatePicker
                  showYearDropdown
                  disabled={calledAs === "view" || calledAs === "lfc"}
                  placeholderText="dd/mm/yyyy"
                  className="form-control"
                  selected={selectedDate}
                  maxDate={currentDate}
                  onChange={(d) => setSelectedDate(d)}
                  dateFormat="dd/MM/yyyy"
                />
              </FormGroup>
            </Col>
          </Row>{" "}
          {errorMessage.frequency && (
            <Row>
              <h5 className="text-error">
                * {<GetLanguageString props={errorMessage.frequency} />}
              </h5>
            </Row>
          )}
          {errorMessage.selectedFrequency && (
            <Row>
              <h5 className="text-error">* {errorMessage.selectedFrequency}</h5>
            </Row>
          )}
          {errorMessage.questions && (
            <Row>
              <h5 className="text-error">
                * {<GetLanguageString props={errorMessage.questions} />}
              </h5>
            </Row>
          )}
        </div>
      </div>
      <div className="panel panel-primary" style={{ borderColor: letterColor }}>
        <div className="panel-body">
          {!loading ? (
            <>
              <LetterForCounsellingDataTable
                questionsList={questionsList}
                setQuestionsList={setQuestionsList}
                setErrorMessage={setErrorMessage}
                errorMessage={errorMessage}
                letterColor={letterColor}
                calledAs={calledAs}
              />{" "}
              {calledAs === "lfc" && commentsData && (
                <div
                  className="ibox"
                  style={{
                    border: "1px solid #e7eaec",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                  }}
                >
                  <div className="ibox-title">
                    <h3>{<GetLanguageString props={"common_comments"} />}</h3>
                  </div>

                  <div className="ibox-content p-4">
                    {letterForCounselling?.includes("ششماہی") &&
                      memberValues.memberResponsibility !== "نقیب" && (
                        <>
                          <FeedbackCard
                            title={<GetLanguageString props="Naqeeb" />}
                            responsibleName={responsibileNames.naqeebName}
                            status={
                              commentsData.HasNaqeebInformedRafiqForTawajah
                            }
                            feedback={commentsData.NaqeebFeedback}
                          />
                          <hr />
                        </>
                      )}
                    {(letterForCounselling?.includes("سہ ماہی") ||
                      letterForCounselling?.includes("ششماہی")) &&
                      memberValues.memberResponsibility !== "مقامی امیر" && (
                        <>
                          <FeedbackCard
                            title={
                              <GetLanguageString props="quick_reports3_muqami_ameer" />
                            }
                            responsibleName={
                              responsibileNames.muqamiAmeerName
                            }
                            status={
                              commentsData.HasMuqamiAmeerInformedRafiqForTawajah
                            }
                            feedback={commentsData.MuqamiAmeerFeedback}
                          />
                          <hr />
                        </>
                      )}
                    {(letterForCounselling?.includes("ماہانہ") ||
                      letterForCounselling?.includes("سہ ماہی") ||
                      letterForCounselling?.includes("ششماہی")) &&
                      memberValues.memberUnitType !== "Markaz" &&
                      memberValues.memberResponsibility !== "امیر حلقہ" &&
                      memberValues.memberResponsibility !== "ناظم اعلیٰ" &&
                      !(
                        letterForCounselling?.includes("ماہانہ") &&
                        memberValues.memberUnitType !== "Markaz" &&
                        memberValues.memberResponsibility ===
                          "نائب ناظم اعلیٰ برائے زون" &&
                        memberValues.memberResponsibility !== "ناظم اعلیٰ"
                      ) && (
                        <>
                          <FeedbackCard
                            title={
                              <GetLanguageString props="quick_reports3_ameer_halqa" />
                            }
                            responsibleName={responsibileNames.ameerHalqaName}
                            status={
                              commentsData.HasAmeerHalqaInformedRafiqForTawajah
                            }
                            feedback={commentsData.AmeerHalqaFeedback}
                          />
                          <hr />
                        </>
                      )}
                    {(letterForCounselling?.includes("ماہانہ") ||
                      (letterForCounselling?.includes("سہ ماہی") &&
                        memberValues.memberResponsibility === "مقامی امیر")) &&
                      memberValues.memberUnitType !== "Markaz" &&
                      memberValues.memberResponsibility !==
                        "نائب ناظم اعلیٰ برائے زون" &&
                      memberValues.memberResponsibility !== "ناظم اعلیٰ" && (
                        <>
                          <FeedbackCard
                            title={
                              <GetLanguageString props="quick_reports3_naib_nazim_alla" />
                            }
                            responsibleName={
                              responsibileNames.naibNazimAllaName
                            }
                            status={
                              commentsData.HasNaibNazimAllaInformedRafiqForTawajah
                            }
                            feedback={commentsData.NaibNazimAllaFeedBack}
                          />
                          <hr />
                        </>
                      )}
                    {letterForCounselling?.includes("ماہانہ") &&
                      memberValues.memberResponsibility ===
                        "نائب ناظم اعلیٰ برائے زون" && (
                        <>
                          <FeedbackCard
                            title={
                              <GetLanguageString props="quick_reports3_nazim_alla" />
                            }
                            responsibleName={responsibileNames.nazimAllaName}
                            status={
                              commentsData.HasNazimAllaInformedRafiqForTawajah
                            }
                            feedback={commentsData.NazimAllaFeedBack}
                          />
                          <hr />
                        </>
                      )}{" "}
                    {letterForCounselling?.includes("ماہانہ") &&
                      memberValues.memberUnitType === "Markaz" && (
                        <>
                          {" "}
                          <FeedbackCard
                            title={
                              <GetLanguageString props="quick_reports3_ameer_tanzeem" />
                            }
                            responsibleName={
                              responsibileNames.ameerMohtaramName
                            }
                            status={
                              commentsData.HasAmeerMohtaramInformedRafiqForTawajah
                            }
                            feedback={commentsData.AmeerMohtaramFeedBack}
                          />
                          <hr />
                        </>
                      )}
                  </div>
                </div>
              )}
              {calledAs === "edit" ? (
                <Row>
                  <div className={GetCustomStyles().btn_style}>
                    {" "}
                    <Button
                      color="primary"
                      size="sm"
                      className={GetCustomStyles().btn_style}
                      onClick={handleSubmit}
                    >
                      <GetLanguageString props="Submit" />
                    </Button>
                  </div>{" "}
                </Row>
              ) : null}
            </>
          ) : (
            LoadingSpinner()
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(EditLetterForCounselling);
